/**
 * Available system colors names in high contrast mode, key names correspond to
 * the color names in Windows Settings for handling disconnect
 * See: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/-ms-high-contrast
 * Internal guidelines: https://office.visualstudio.com/DefaultCollection/OC/_wiki/wikis/OC.wiki/17315/High-Contrast-Guidelines
 */ export const HighContrastColors = {
    /** Default background color  */ Background: 'canvas',
    /** The text color to use in high contrast */ Text: 'canvasText',
    /** Color for a hyper link */ HyperlinkText: 'linkText',
    /** Color for visited links */ HyperlinkVisitedText: 'visitedText',
    /** Color for active links */ HyperlinkActiveText: 'activeText',
    /** The background color for a button */ ButtonBackground: 'buttonFace',
    /** Color that text should be on a button */ ButtonText: 'buttonText',
    /** Color that text should be on a button */ ButtonBorder: 'buttonBorder',
    /** The background color for selected text */ SelectedBackground: 'highlight',
    /** The color text should be when selected */ SelectedText: 'highlightText',
    /** Background of text that has been specially marked (such as by the HTML mark element) */ MarkBackground: 'mark',
    /** Text that has been specially marked (such as by the HTML mark element) */ MarkText: 'markText',
    /** The color text should be when disabled */ DisabledText: 'grayText',
    /** Default background color for IE and MS Edge Legacy */ Window: 'window',
    /** The Color of the text content */ WindowText: 'windowText'
};
